module.exports = __webpack_public_path__ + "static/img/parbuild.3eef8680.png";